import {API_URL, THEME_COLOR, numberWithCommas, CMS_URL} from "../../constant"
import React, {useEffect, useState} from 'react';
import { useLocalStorage } from "../../useLocalStorage";
import toast, { Toaster } from 'react-hot-toast';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack } from "@mui/material";


import SlidingPane from 'react-sliding-pane';
import "react-sliding-pane/dist/react-sliding-pane.css";


import Warehouse from "./Warehouse";

let FAO = (props)=>{
    
    const [token, setToken] = useLocalStorage("token", "");
    const [wh, setWh] = useLocalStorage("wh", "");
    const [isExpanded, setIsExpanded] = useState(true);
    const [faos, setfaos] = useState([]);
    const [selectedFAO, setSelectedFAO] = useState({}); 
    const [warehouse, setWarehouse] = useState({})
    const [warehouses, setWarehouses] = useState({})
    const [isOpenWarehouse, setIsOpenWarehouse] = useState(false);


    function changeIsOpenWarehouse(val){
        setIsOpenWarehouse(val)
    }

    async function selectFAO(value){
        setSelectedFAO(value);
        setIsExpanded(false);

        let allwh = props.items.map((val, idx) => val.WarehouseDetail.WarehouseID)


        let data = await getStock(value.ItemUnitID, allwh);
        if(data){
            if(data.status == 200){
                data = data.data;
                setWarehouses(data)
                if(data && data.length> 0){
                    setWarehouse({
                        ID: data[0].WarehouseID,
                        CompanyID: data[0].CompanyID,
                        BranchID: data[0].BranchID,
                        WarehouseID: data[0].WarehouseID,
                        Name : data[0].WarehouseName,  
                        Stock : data[0].QtyEnd,  
                        CityID: data[0].CityID,
                        CityName : data[0].CityName,
                        ProvinceID: data[0].ProvinceID,
                        ProvinceName: data[0].ProvinceName,
                        Address : data[0].WarehouseAddress,  
                    })
                }else{
                    setWarehouse({
                        ID: 0,
                        Name: "",
                        Stock: 0,
                    })
                }
            }
            else{
                toast.error(data.message)
            }
        }else{
            toast.error("couldn't connect to server")
        }
    }

    function submitHandler(){
        if(selectedFAO.Name && selectedFAO.Name != "" &&  warehouse.ID && warehouse.ID != 0){

            let titems = [...props.items]
            let prevfao = {...props.fao}
    
            if(prevfao.ItemUnitID){
                let removeidx = titems.findIndex(object => {
                    return object.ItemUnitID === prevfao.ItemUnitID;
                });
                titems.splice(removeidx, 1);
            }
    
            let insertidx = -1
            let shippingmethod = "";
            let ShippingDetail = {};
            let WarehouseDetail = {}
            titems.forEach((element, idx) => {
                if(element.WarehouseDetail.WarehouseID == warehouse.ID){
                    insertidx = idx;
                    shippingmethod = element.ShippingMethod
                    ShippingDetail = element.ShippingDetail;
                    WarehouseDetail = element.WarehouseDetail;
                }
            });
    
            if(insertidx != -1){
                insertidx += 1;
                let itemobj = {
                    ID: 888888,
                    PromoID: 0,
                    PromoCode: '',
                    PromoName: '',
                    ItemID: selectedFAO.ID,
                    ItemUnitID: selectedFAO.ItemUnitID,
                    ItemName: selectedFAO.Name,
                    ItemQty: 1,
                    ItemUoM: "PCS",
                    ItemPrice: 0,
                    ItemWeight: selectedFAO.Weight,
                    IsChecked : 1,
                    Stock: warehouse.Stock,
                    WarehouseDetail:WarehouseDetail,
                    ShippingMethod: shippingmethod,
                    ExpeditionDetail: {
                        ExpeditionCode: "",
                        ExpeditionName: "",
                        ExpeditionFee: 0,
                    },
                    ShippingDetail:ShippingDetail
                }
                titems.splice(insertidx, 0, itemobj)
                props.setItems(titems);
                props.setfao(selectedFAO);
                props.changeIsOpenFAO(false)
            }else{
    
            }
        }else{
            toast.error(`please select 1 FAO and the warehouse`)
        }

    }

    function getFAO(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/fao`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }
    
    function getStock(itemunitid, allwh){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("x-wh", wh);

        var urlencoded = new URLSearchParams();
        urlencoded.append("allwh", JSON.stringify(allwh));
        urlencoded.append("itemunitid", itemunitid);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/item/stock`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }
    
    useEffect(async ()=>{
        // setSelectedCoupons(props.coupons)
        let response = await getFAO();
        if(response.status == 200){
            setfaos(response.data);
        }else{
            toast.error(response.message);
        }

        
    },[]);

    return (
        <>
            <Accordion expanded={isExpanded} onChange={()=>setIsExpanded(true)}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>FAO</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {
                        faos.map((value,index)=>{
                            let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                            if(value.ImageName){
                                imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                            }
                            return (
                                <Stack
                                    direction='row'
                                    alignItems='center'

                                >
                                    <img style={{width: '50px', height: '50px', marginRight:"10px"}} src={imgurl}/>
                                    <div style={{flexGrow:1}}>{value.Name}</div>
                                    <div>
                                        <button className={`btn ${THEME_COLOR}`} style={{minWidth:"100px"}} onClick={()=>selectFAO(value)}>
                                            {
                                                (selectedFAO.ItemUnitID == value.ItemUnitID) ?(
                                                    `SELECTED`
                                                ):(
                                                    `SELECT`
                                                )
                                            }
                                        </button>
                                    </div>
                                </Stack>
                            );
                        })
                    }
                </AccordionDetails>
            </Accordion>
            <div className="shipping-container">
                <div className="detail-header">Warehouse</div>
                <div style={{marginBottom:"20px"}}>
                    <div className="shipping-info-container" style={{padding:"10px"}}>
                        <div className="shipping-information-header">{warehouse.Name}</div>
                        <div className="shipping-information-header">Stock: {warehouse.Stock}</div>
                        <div></div>
                        {(warehouse.CityName && warehouse.CityName != "") ? (
                            <div>{warehouse.Address}, {warehouse.CityName}, {warehouse.ProvinceName}, Indonesia</div>) : <></>}
                        <hr/>
                        <div className="right-align">
                            <button className={`btn ${THEME_COLOR}`} disabled={!selectedFAO.Name || selectedFAO.Name == ""} onClick={()=> setIsOpenWarehouse(true)}>Change</button>
                        </div>

                    </div>
                </div>
            </div>
            <div className="reward-bottom">
                <div className="cart-footer">
                    <div className="" style={{"flexGrow":1}}>
                        {/* <div className="cart-footer-sub">Total Reward</div><div className="cart-footer-price">Rp {numberWithCommas(totalReward)}</div> */}
                        <div>Selected FAO</div>
                        <div className="reward-price">
                            {
                                (selectedFAO.Name && selectedFAO.Name != "")? (selectedFAO.Name) : (`NO SELECTED FAO`)
                            }
                        </div>
                    </div>
                    <div style={{"margin": "5px 30px","textAlign":"center"}}>
                        <button className={`btn ${THEME_COLOR}`} style={{minWidth:"100px"}} onClick={()=> submitHandler()}>Done</button>
                    </div>
                </div>
            </div>
            <SlidingPane
                className="cart-expedition-panel"
                closeIcon={<span><i className="material-icons">close</i></span>}
                isOpen={isOpenWarehouse}
                title="Choose Warehouse"
                from="bottom"
                width= "100%"
                onRequestClose={() => setIsOpenWarehouse(false)}
            >
                <Warehouse
                    warehouses = {warehouses}
                    changeIsOpenWarehouse = {changeIsOpenWarehouse}
                    setWarehouse = {setWarehouse}
                />
            </SlidingPane>
        </>
    );
}

export default FAO;